<template>
  <div class="main-container">
    <div class="search-bar">
      <div class="p-inputgroup">
        <InputText placeholder="Enter full or partial Human Readable" v-model="searchTerm"
                   v-on:keydown.enter="searchEvents"/>
        <Button icon="pi pi-search" v-on:click="searchEvents" :disabled="!isValidSearch"/>
      </div>
    </div>

<div v-if="isLoadingEvents">
      <div class="loading-events p-mt-5">
        <i class="pi pi-spin pi-spinner p-m-auto" style="fontSize: 4rem"/>
      </div>
    </div>

    <div class="result-content" v-else-if="events.length > 0 && !isLoadingEvents">
      <div class="image-and-event-list p-grid p-mt-1">
        <div class="p-col-8 full-height">
          <div v-if="selectedEvent" class="full-height">
            <VueLoadImage class="picture-container">
              <img class="barcode-picture" slot="image" :src="imageUrl"/>
              <div slot="preloader" class="loading-container">
                <i class="pi pi-spin pi-spinner p-m-auto loading-icon"/>
              </div>
              <div slot="error">Failed to pull product image.</div>
            </VueLoadImage>
          </div>
        </div>

        <div class="p-col-4 full-height">
          <EventList :events="events" class="product-events"
                     v-on:event-selected="eventSelected"></EventList>
        </div>
      </div>

      <div class="event-details">
        <EventDetails :selected-event="selectedEvent" v-if="selectedEvent"></EventDetails>
      </div>

    </div>

    <div class="result-content" v-else-if="events.length === 0 && !isLoadingEvents">
      <div class="p-text-center p-text-bold" style="fontSize: 2rem">No result matching with the request</div>
    </div>

  </div>
</template>

<script>
import DfpService from '../../services/DfpService';
import EventDetails from './eventDetails';
import EventList from './eventList';
import VueLoadImage from 'vue-load-image'

export default {
  name: 'ImageSearch',
  props: {},
  components: {
    "EventDetails": EventDetails,
    "EventList": EventList,
    "VueLoadImage": VueLoadImage,
  },
  data() {
    return {
      imageUrl: null,
      dfpService: null,
      events: [],
      searchTerm: "",
      selectedEvent: null,
      isLoadingEvents: false,
    }
  },
  computed: {
    isValidSearch: function () {
      return this.searchTerm.length >= 4;
    }
  },
  methods: {
    searchEvents() {
      if(!this.isValidSearch) {
        return;
      }

      this.isLoadingEvents = true;
      this.dfpService.getEvents(this.searchTerm, this.$auth.accessToken)
          .then(response => {
            this.events = response.data;
            this.isLoadingEvents = false;
          });
    },
    eventSelected(event) {
      this.selectedEvent = event;
      this.dfpService.getImageUrl(this.selectedEvent.image_uid, this.$auth.accessToken)
          .then((imageUrl) => {
            this.imageUrl = imageUrl;
          });
    }
  },
  created() {
    this.dfpService = new DfpService();
  },

}
</script>

<style scoped>
.main-container {
  height: 100%;
  width: 90%;
  max-height: 100%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
  padding: 10px;
}

.result-content {
  height: 100%
}

.product-events {
  max-width: 100%;
  max-height: 100%
}

.loading-events {
  display: flex;
}

.image-and-event-list {
  height: 70%;
}

.event-details {
  height: 20%;
}

.search-bar {
  height: 10%;
}


.loading-container {
  display: flex;
  height: 100%;
}

.loading-icon {
  font-size: 4rem;
}

.barcode-picture {
  max-width: 100%;
  max-height: 100%;
}

.picture-container {
  display: block;
  margin: auto;
  height: 100%;
}

.full-height {
  height: 100%;
}


</style>